import { Button } from "@/components/ui/button"
import { ButtonGroup } from "@/components/ui/button-group"
import {
  dataByCompanySection,
  ORDERED_COMPANY_SECTIONS,
} from "@/constants/company/company-section"
import { cn } from "@/lib/utils"

const NAV_ITEMS = ORDERED_COMPANY_SECTIONS.filter(
  (section) => dataByCompanySection[section].navLabel
).map((section) => ({
  id: section,
  label: dataByCompanySection[section].navLabel!,
}))

export function CompanyNav({ className }: { className?: string }) {
  return (
    <ButtonGroup
      className={cn("no-scrollbar divide-x-2 overflow-x-auto", className)}
      role="navigation"
    >
      {NAV_ITEMS.map((item, index) => (
        <Button
          key={item.id}
          variant="ghost"
          className="gap-2"
          shouldRenderAsChild
        >
          <a href={`#${item.id}`}>
            <span className="flex h-5 w-5 items-center justify-center border text-[10px] font-medium">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="text-sm font-bold uppercase">{item.label}</span>
          </a>
        </Button>
      ))}
    </ButtonGroup>
  )
}
